const EventTypes = require('../constants/events');

const baseEvent = {
  _version: 4,
  uid: '',
  type: EventTypes.UNSPECIFIED,
  name: 'Event',
  description: 'Event description',
  player: '',
  details: {},
  created: '',
  updated: '',
};

const createEvent = (overrides = {}) => {
  return { ...baseEvent, ...overrides };
};

const duplicateEvent = event => ({
  ...event,
  details: { ...event.details }
});

module.exports = {
  createEvent,
  duplicateEvent
};
